import { get, post, delet, put } from '@/core/h5/request'
import { data } from 'jquery';
import Cookies from 'js-cookie';

export const preFetchImg = (fileId) => {
    const options = {
        url: `/file/preview/other/${fileId}`,
        baseURL: process.env.VUE_APP_INNERNET_URL,
    }
    return get(options)
}

export const getFileDetail = (fileId) => {
    const options = {
        url: `/file/api/file/detail/${fileId}`,
        baseURL: process.env.VUE_APP_INTERNET_URL,
    }
    return get(options)
}

/// 预览前置检查
/// Result如下
/// isPublic Boolean - 是否公开,即是否开启互联网访问
/// auth String - 访问权限 1:仅查看 READ(0) 2:查看和下载 READ_DOWNLOAD(1) 3: 编辑 WRITE(2) 4: 所有权限 ALL(3)
export const checkFile = (fileId, password = '') => {
    const options = {
        data: { password },
        url: `/file/api/file/preview/check/${fileId}`,
        baseURL: process.env.VUE_APP_INTERNET_URL,
        // baseURL: '/resources'
        // url: `/resources/file/api/file/preview/check/${fileId}`,
    }
    return post(options)
}

/// 获取文档节点信息并添加查看记录
export const queryFileNodeInfo = (fileId) => {
    const options = {
        url: `/file/api/file/node/${fileId}`,
        baseURL: process.env.VUE_APP_INTERNET_URL,
    }
    return get(options)
}

/// 查询知识库信息
export const getKBInfo = (fileId) => {
    const options = {
        url: `/file/api/wiki/space/preview`,
        params: { fileId },
        baseURL: process.env.VUE_APP_INTERNET_URL,
    };
    return get(options);
};

export const getFiles = (data) => {
    const options = {
        data: data,
        url: '/file/api/public/file/list',
        baseURL: process.env.VUE_APP_INTERNET_URL,
    }
    return post(options)
}

/// 申请文件权限
export const applyFileAuth = (auth, fileId, reason) => {
    const options = {
        data: { auth: auth, fileId: fileId, reason: reason },
        url: '/file/api/share/auth/apply',
        baseURL: process.env.VUE_APP_INTERNET_URL,
    }
    return post(options)
}

/// 链接分享 - 授权
/// fileId string 文件ID 必需
/// auth string 权限 可选 - WRITE：编辑权限 READ_DOWNLOAD：查看下载 READ：仅查看
/// scope string 分享范围 必须 - PUBLIC：互联网 ORGANIZATION：组织内 COLLABORATOR：仅协作者
export const shareAuth = (fileId, auth, scope) => {
    const options = {
        data: {
            fileId: fileId,
            auth: auth,
            scope: scope,
        },
        url: '/file/api/share/url/auth',
        baseURL: process.env.VUE_APP_INTERNET_URL,
    }
    return post(options)
}

/// 链接分享 - 获取链接分享信息
/// fileId string 文件ID 必需
export const getShareInfo = (fileId) => {
    const options = {
        url: `/file/api/share/url/auth/${fileId}`,
        baseURL: process.env.VUE_APP_INTERNET_URL,
    }
    return get(options)
}

/// 查询文件授权协作者列表
export const getShareAuthList = (fileId) => {
    const options = {
        params: { fileId: fileId },
        // url: '/file/api/share/auth/list',
        url: '/file/api/share/info',
        baseURL: process.env.VUE_APP_INTERNET_URL,
    }
    return get(options)
}

/// 获取文件分享链接
export const getShareUrl = (fileId) => {
    const options = {
        url: `/file/api/share/url/${fileId}`,
        baseURL: process.env.VUE_APP_INTERNET_URL,
    }
    return get(options)
}

/// 查询用户对指定文件的权限列表
export const getUserAuthList = (fileId) => {
    const options = {
        url: `/file/api/file/permission/${fileId}`,
        baseURL: process.env.VUE_APP_INTERNET_URL,
    }
    return get(options)
}

/// 权限删除
export const deleteAuth = (id, pushMessage, fileId, toSpace, toType) => {
    const options = {
        data: {
            to: id,
            pushMessage: pushMessage,
            toSpace: toSpace,
            toType: toType,
        },
        url: `/file/api/share/auth/delete/${fileId}`,
        baseURL: process.env.VUE_APP_INTERNET_URL,
    }
    return delet(options)
}

/// 权限继承恢复
export const recoverAuth = (fileId) => {
    const options = {
        url: `/file/api/share/auth/recover/${fileId}`,
        baseURL: process.env.VUE_APP_INTERNET_URL,
    }
    return post(options)
}

/// 文件授权
export const setFileAuth = (data) => {
    const options = {
        data: data,
        url: '/file/api/share/auth',
        baseURL: process.env.VUE_APP_INTERNET_URL,
    }
    return post(options)
}

/// 保存有效期
export const saveExpireTime = (fileId, expireDate) => {
    const options = {
        data: {
            fileId: fileId,
            expireDate: expireDate,
        },
        url: '/file/api/share/public/expire/save',
        baseURL: process.env.VUE_APP_INTERNET_URL,
    }
    return post(options)
}

/// 删除有效期
export const deleteExpireTime = (fileId) => {
    const options = {
        data: {
            fileId: fileId,
        },
        url: '/file/api/share/public/expire/delete',
        baseURL: process.env.VUE_APP_INTERNET_URL,
    }
    return post(options)
}

/// 创建密码
export const createPassword = (fileId) => {
    const options = {
        data: {
            fileId: fileId,
        },
        url: '/file/api/share/public/passwd/create',
        baseURL: process.env.VUE_APP_INTERNET_URL,
    }
    return post(options)
}

/// 刷新密码
export const refreshPassword = (fileId) => {
    const options = {
        data: {
            fileId: fileId,
        },
        url: '/file/api/share/public/passwd/refresh',
        baseURL: process.env.VUE_APP_INTERNET_URL,
    }
    return post(options)
}

/// 删除密码
export const deletePassword = (fileId) => {
    const options = {
        data: {
            fileId: fileId,
        },
        url: '/file/api/share/public/passwd/delete',
        baseURL: process.env.VUE_APP_INTERNET_URL,
    }
    return post(options)
}

/// 获取memberUniqueId
export const getMemberUniqueId = (authCode) => {
    const options = {
        params: { authCode: authCode },
        url: '/meeting/sdk-meeting-minutes/user',
        baseURL: process.env.VUE_APP_BASE_URL,
    }
    return get(options)
}

/// 使用memberUniqueId登录
export const useMemberUniqueIdToLogin = (data) => {
    const options = {
        data: data,
        url: '/login/web/member-unique-id',
        baseURL: process.env.VUE_APP_BASE_URL,
    }
    return post(options)
}

/// 使用user_id及 memberId获取获取会议纪要应用配置
export const getMeetingConfig = (userId) => {
    const options = {
        params: { userId: userId },
        url: '/meeting/sdk-meeting-minutes/config',
        baseURL: process.env.VUE_APP_BASE_URL,
    }
    return get(options)
}

/// 获取会议纪要文件id
export const getFileId = (meetingId) => {
    const options = {
        url: `/meeting/meeting-minutes/${meetingId}`,
        baseURL: process.env.VUE_APP_BASE_URL,
    }
    return get(options)
}

/// 文件重命名
export const renameFileTitle = (data) => {
    const options = {
        data,
        url: `/file/api/file/rename`,
        baseURL: process.env.VUE_APP_BASE_URL,
    }
    return post(options)
}

/// 创建文件
export const createFile = (data) => {
    const options = {
        data,
        url: `/file/api/document/new`,
        baseURL: process.env.VUE_APP_BASE_URL,
    }
    return post(options)
}

/// 创建文件夹
export const createFolder = (data) => {
    const options = {
        data,
        url: `/file/api/document/mkdir`,
        baseURL: process.env.VUE_APP_BASE_URL,
    }
    return post(options)
}
/// 删除文件
export const deleteFile = (data) => {
    const options = {
        data,
        url: `/file/api/file/delete`,
        baseURL: process.env.VUE_APP_BASE_URL,
    }
    return post(options)
}

/// 创建文件夹
export const noticeDownloadFolder = (fileId, deviceId) => {
    const options = {
        url: `/stream/api/public/download/zip/create/${fileId}`,
        baseURL: process.env.VUE_APP_NEW_STREAM_DOWNLOAD,
        headers: {
            'deviceId': deviceId,
        },
    }
    return post(options)
}

/// 获取最近文件列表
export const getRecentFile = (data) => {
    const options = {
        params: data,
        url: '/file/api/document/recent',
        baseURL: process.env.VUE_APP_BASE_URL,
    }
    return get(options)
}

export const getMineFiles = (data) => {
    const userId = Cookies.get('userId');
    const spaceId = Cookies.get('spaceId');
    data['parentId'] = spaceId + '_' + userId + '_doc';
    const options = {
        params: data,
        url: '/file/api/document/list',
        baseURL: process.env.VUE_APP_BASE_URL,
    };
    return get(options);
};

export const getRecentKBs = (data) => {
    const options = {
        params: data,
        url: '/file/api/wiki/space',
        baseURL: process.env.VUE_APP_BASE_URL,
    };
    return get(options);
};

export const getRecentStars = (data) => {
    const options = {
        params: data,
        url: '/file/api/file/star',
        baseURL: process.env.VUE_APP_BASE_URL,
    };
    return get(options);
};


// 获取新建文件配置项
export const getCreateOptions = (data) => {
    const options = {
        params: data,
        url: '/app/client/menus/menu-resource',
        baseURL: process.env.VUE_APP_BASE_URL,
    }
    return get(options)
}

// 获取新编辑器阅读/编辑模式
export const getEditorMode = (data) => {
    const { fid, settingsCode } = data
    const options = {
        url: `/file/api/file/settings/${fid}?settingsCode=${settingsCode}`,
        baseURL: process.env.VUE_APP_BASE_URL,
    }
    return get(options)
}

// 设置新编辑器阅读/编辑模式
export const setEditorMode = (data, fid) => {
    const options = {
        data,
        url: `/file/api/file/settings/${fid}`,
        baseURL: process.env.VUE_APP_BASE_URL,
    }
    return post(options)
}

// 收藏 or 取消收藏
export const starFile = (star, fid) => {
    const options = {
        data: { star },
        url: `/file/api/file/star/${fid}`,
        baseURL: process.env.VUE_APP_BASE_URL,
    }
    return post(options)
}

/// 转移权限搜索用户
export const searchMember = (key, enabledSearchUnitedSpaces) => {
    const options = {
        params: { searchKey: key, enabledSearchUnitedSpaces: enabledSearchUnitedSpaces },
        url: '/uic/web/member/fuzzy-search',
        baseURL: process.env.VUE_APP_BASE_URL,
    }
    return get(options)
}

/// 发送会议纪要
export const sendMettingEmail = (data, fileId) => {
    const options = {
        data: data,
        url: `/meeting/meeting-minutes/${fileId}/send-email`,
        baseURL: process.env.VUE_APP_BASE_URL,
    }
    return post(options)
}

/// 根据远端地址获取file数据
export const getLocalURLApi = (url) => {
    const options = {
        responseType: 'blob',
        url: url,
        timeout: 0,
        baseURL: process.env.VUE_APP_UPLOAD,
    };
    return get(options);
};

/// 上传图片
export const uploadEmailImage = (data) => {
    const options = {
        params: data,
        url: `/meeting/meeting-minutes/upload-email-image`,
        baseURL: process.env.VUE_APP_BASE_URL,
    }
    return post(options)
}

/// 转移文档所有权
export const transferFileOwner = (fileId, data) => {
    const options = {
        data: data,
        url: `/file/api/file/transfer/${fileId}`,
        baseURL: process.env.VUE_APP_BASE_URL,
    }
    return post(options)
}

/// 保存偏好设置
export const saveEditorSetting = (data, fileId) => {
    const options = {
        data: {
            settingsCode: "FILE.PAGE_WIDTH_MODE",
            settingsValue: data
        },
        url: `/file/api/file/settings/${fileId}`,
        baseURL: process.env.VUE_APP_BASE_URL,
    }
    return post(options)
}

/// 查询轻文档宽度设置
export const getEditorWidthSetting = (fileId) => {
    const options = {
        params: { settingsCode: 'FILE.PAGE_WIDTH_MODE' },
        url: `/file/api/file/settings/${fileId}`,
        baseURL: process.env.VUE_APP_BASE_URL,
    }
    return get(options)
}

/// 查询默认连接分享范围设置
export const getLinkShareRangeSetting = (fileId) => {
    const options = {
        params: { settingsCode: 'FILE.DEFAULT_URL_AUTH' },
        url: `/file/api/file/settings/${fileId}`,
        baseURL: process.env.VUE_APP_BASE_URL,
    }
    return get(options)
}

/// 检查文件重名
export const checkFileName = (data) => {
    const options = {
        data: data,
        url: `/file/api/document/upload/init/name`,
        baseURL: process.env.VUE_APP_BASE_URL,
    }
    return post(options)
}

// 获取用户信息
export const fetchUserInfo = async (parm) => {
    const { spaceId, userId } = parm
    return get({
        url: `/uic/web/member/detail?spaceId=${spaceId}&userId=${userId}`,
        baseURL: '',
    })
}

/// 查询文件配置的非管理员最大权限
export const nonAdminMaxAuth = (fileId) => {
    const options = {
        url: `/file/api/file/config/${fileId}/non-admin-max-auth`,
        baseURL: process.env.VUE_APP_BASE_URL
    };
    return get(options);
};

/// 查询文件配置的审批人
export const queryAuthApprovers = (fileId) => {
    const options = {
        url: `/file/api/file/config/${fileId}/auth-approvers`,
        baseURL: process.env.VUE_APP_BASE_URL
    };
    return get(options);
};

//获取文件面包屑
export const queryFilePath = (fileId, withRoot) => {
    const options = {
        params: { withRoot },
        url: `/file/api/document/path/${fileId}`,
        baseURL: process.env.VUE_APP_BASE_URL
    };
    return get(options);
};

// 开启水印
export const enableWatermark = (data) => {
    const options = {
        data: data,
        url: `/file/api/share/public/watermark/enabled`,
        baseURL: process.env.VUE_APP_BASE_URL,
    }
    return post(options)
}

// 关闭水印
export const disableWatermark = (data) => {
    const options = {
        data: data,
        url: `/file/api/share/public/watermark/disabled`,
        baseURL: process.env.VUE_APP_BASE_URL,
    }
    return post(options)
}

// 获取未登录水印文本
export const fetchWatermarkText = (fileId) => {
    const options = {
        url: `/file/api/file/preview/watermark-text/${fileId}`,
        baseURL: process.env.VUE_APP_BASE_URL
    };
    return get(options);
};

//转换为模板
export const convertTemplate = (fileId) => {
    const options = {
        params: { fileId },
        url: `/file/api/file/template/convert`,
        baseURL: process.env.VUE_APP_BASE_URL
    };
    return post(options);
};

//保存为我的模板
export const saveToMineTemplate = (fileId) => {
    const options = {
        params: { fileId },
        url: `/file/api/file/template/save-as-my`,
        baseURL: process.env.VUE_APP_BASE_URL
    };
    return post(options);
};

//模版详情接口
export const templateDetail = (fileId) => {
    const options = {
        url: `/file/api/file/template/detail/${fileId}`,
        baseURL: process.env.VUE_APP_BASE_URL
    };
    return get(options);
};

// 查询文档访问记录
export const getFileViewRecord = (fileId, since, size) => {
    const options = {
        url: `/file/api/file/view-records/${fileId}`,
        params: { since, size },
        baseURL: process.env.VUE_APP_BASE_URL
    };
    return get(options);
}

// 查询文档操作记录
export const getFileOperateRecords = (fileId, since, size, scene) => {
    const options = {
        url: `/file/api/file/operate-records/${fileId}`,
        params: { since, size, scene },
        baseURL: process.env.VUE_APP_BASE_URL
    };
    return get(options);
}

// 修改文件预览模式
export const setOfficePreviewMode = (fileId, enabledOfficePreview) => {
    const options = {
        data: { enabledOfficePreview },
        url: `/file/api/file/config/office-preview-mode/${fileId}`,
        baseURL: process.env.VUE_APP_BASE_URL
    };
    return put(options);
};

// 文件风险整改完成
export const recognizeRisk = (fileId) => {
    const options = {
        url: `/file/api/file/risk/recognize/${fileId}`,
        baseURL: process.env.VUE_APP_BASE_URL
    };
    return post(options);
};

// 文件风险误判
export const feedbackRisk = (fileId) => {
    const options = {
        url: `/file/api/file/risk/feedback/${fileId}`,
        baseURL: process.env.VUE_APP_BASE_URL
    };
    return post(options);
};

//// 获取可复制权限(仅管理员使用)
export const getCopyAuth = (fileId) => {
    const options = {
        url: `/file/api/permission/settings/${fileId}`,
        baseURL: process.env.VUE_APP_INTERNET_URL,
    }
    return get(options)
}

/// 设置可复制权限
export const setCopyAuth = (fileId, data) => {
    const options = {
        data: data,
        url: `/file/api/permission/settings/${fileId}`,
        baseURL: process.env.VUE_APP_INTERNET_URL,
    }
    return post(options)
}

// 查询文档节点权限（包含可复制权限）
export const getFileNodePermission = (fileId) => {
    const options = {
        url: `/file/api/file/node/permission/${fileId}`,
        baseURL: process.env.VUE_APP_INTERNET_URL,
    }
    return get(options)
}

// -------------------------------------------------------------移动、创建副本、基于模版创建

/// 知识库创建副本
export const kbCreateCopy = (fileId, targetId, fileName) => {
    const options = {
        data: { fileId, targetId, fileName },
        url: `/file/api/wiki/tree/node/copy`,
        baseURL: process.env.VUE_APP_BASE_URL
    };
    return post(options);
};

/// 创建云文档文件副本
export const createCopyCloudDocumentFile = (fileId, targetId, fileName) => {
    const options = {
        data: { fileId, targetId, fileName },
        url: `/file/api/file/duplicate`,
        baseURL: process.env.VUE_APP_BASE_URL,
    };
    return post(options);
};


/// 知识库新建文件
export const kbCreateFile = (productType, newFileType, parentId, templateFileId, fileName) => {
    const options = {
        data: { productType, newFileType, parentId, templateFileId, fileName },
        url: `/file/api/file/new`,
        baseURL: process.env.VUE_APP_BASE_URL
    };
    return post(options);
};

/// 跨级拖动和排序
export const fileMove = (fileId, targetId, sortNo) => {
    const options = {
        data: { fileId, targetId, sortNo },
        url: `/file/api/file/move`,
        baseURL: process.env.VUE_APP_BASE_URL
    };
    return post(options);
};